// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"7c3d256f","769":"fdc7db50"}[chunkId] + ".chunk.js";
};